/* import __COLOCATED_TEMPLATE__ from './stack.hbs.js'; */
import Component from '@glimmer/component';
export default class Stack extends Component {
  get fill() {
    return this.args.fill || 'var(--core-fill-10-color)';
  }
  get height() {
    return this.args.height || '16';
  }
  get width() {
    return this.args.width || '16';
  }
}